import { IRootTraffic, $RootTraffic as $OriginRootTraffic } from '@lemon8/web-app-shared/atom';
import { EPageType } from 'shared/constant/page-type';
import { PrimitiveAtom } from 'jotai';

export interface ISharingRootTraffic extends IRootTraffic {
  enterPageName: EPageType;
  enterPageId: string;

  // timestamp - 10bits
  // shareTime: string;
  // sharerUid: string;
  // sharerDid: string;

  sharerToken: string;

  sharePlatform: string;

  isSharingTest: boolean;
}

export const $RootTraffic = $OriginRootTraffic as unknown as PrimitiveAtom<ISharingRootTraffic>;
